import { render } from "./Ruduud.vue?vue&type=template&id=8330b40c&scoped=true"
import script from "./Ruduud.vue?vue&type=script&lang=js"
export * from "./Ruduud.vue?vue&type=script&lang=js"

import "./Ruduud.vue?vue&type=style&index=0&id=8330b40c&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8330b40c"]])

export default __exports__